import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";

function OrderItemEdit({ openDialog, editingItem, setEditingItem }) {
  const [editedItemData, setEditedItemData] = useState({
    quantity: 0,
    price: 0,
  });

  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  // When editingItem changes, update the state to reflect the item's data
  useEffect(() => {
    if (editingItem) {
      setEditedItemData({
        quantity: editingItem.quantity,
        price: editingItem.price,
      });
    }
  }, [editingItem]);

  // Close the dialog when the cancel button is clicked
  const handleDialogClose = () => {
    setEditingItem(null);
  };

  // Function to update the order item quantity
  const EditOrderItem = async () => {
    const { quantity, price } = editedItemData;

    if (quantity <= 0 || price <= 0) {
      toast("Please enter valid quantity and price.");
      return;
    }

    const updatedOrderData = {
      order_item_id: editingItem.id,
      quantity: quantity,
      price: price,
    };

    try {
      const updateResponse = await axios.post(
        `${API_BASE_URL}/orders/editOrderItemQuantity`,
        updatedOrderData
      );

      if (updateResponse.status === 200) {
        toast("Order item updated successfully!");
        handleDialogClose();
      } else {
        toast(
          updateResponse.data.status_message || "Failed to update order item."
        );
      }
    } catch (err) {
      toast("An error occurred while updating the order item.");
      console.error("Error Details: ", err);
    }
  };

  return (
    <Dialog open={openDialog} onClose={handleDialogClose}>
      <DialogTitle>Edit Order Item</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          label="Item Name"
          value={editingItem?.item_name || ""}
          fullWidth
          InputProps={{
            readOnly: true,
          }}
        />

        <TextField
          margin="dense"
          label="Price"
          value={editedItemData.price}
          fullWidth
          onChange={(e) =>
            setEditedItemData({ ...editedItemData, price: e.target.value })
          }
        />

        <TextField
          margin="dense"
          label="Quantity"
          type="number"
          fullWidth
          value={editedItemData.quantity}
          onChange={(e) =>
            setEditedItemData({ ...editedItemData, quantity: e.target.value })
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDialogClose} color="primary">
          Cancel
        </Button>
        <Button onClick={EditOrderItem} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OrderItemEdit;
